<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post18-attacks-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post18-attacks-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.26654409042975;"
    data-aspect-ratio="0.267"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post18-attacks-xs-img"
      class="g-post18-attacks-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post18-attacks-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs"
      style="top:4.927%;left:11.3481%;width:76.9697%;"
    >
      <p class="g-pstyle1">
        The attack drones Iran has used through the conflict are capable of
        striking ships. UAVs are relatively low‑cost, can be launched in
        numbers, and are difficult for civilian ships to defend against without
        naval escorts.
      </p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:29.6966%;margin-top:-9.7px;left:10.4909%;width:98px;"
    >
      <p class="g-pstyle2">Iran&rsquo;s shore</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs"
      style="top:38.447%;right:58.6376%;width:37.5758%;"
    >
      <p class="g-pstyle3">Shore‑based anti‑ship missiles</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs"
      style="top:41.8393%;right:58.3763%;width:39.0909%;"
    >
      <p class="g-pstyle4">
        Iran deploys coastal missile batteries along its shoreline and islands
        overlooking key sea lanes.
      </p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.3395%;margin-top:-9.7px;left:31.87%;margin-left:-52.5px;width:105px;"
    >
      <p class="g-pstyle5">Civilian ship</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs"
      style="top:72.1284%;right:63.5596%;width:33.9394%;"
    >
      <p class="g-pstyle3">Naval mines</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs"
      style="top:73.9862%;right:63.3558%;width:33.0303%;"
    >
      <p class="g-pstyle4">
        Tehran may also deploy mines in the strait. U.S. intelligence estimates
        Iran has stockpiled as many as 6,000 mines, including drifting, limpet,
        bottom and moored mines.
      </p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs"
      style="top:74.39%;left:60.2258%;width:33.9394%;"
    >
      <p class="g-pstyle0">Unmanned surface vessels</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs"
      style="top:77.7016%;left:60.2258%;width:33.9394%;"
    >
      <p class="g-pstyle1">
        Another method is explosive‑laden unmanned boats or remotely operated
        craft. These are designed to approach ships near the waterline and
        detonate.
      </p>
    </div>
    <div
      id="g-ai0-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:98.0221%;margin-top:-9.6px;right:46.5613%;width:185px;"
    >
      <p class="g-pstyle6">Note: Diagram is not to scale.</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs"
      style="top:1.4539%;left:11.3481%;width:41.2121%;"
    >
      <p class="g-pstyle0">Unmanned aerial vehicles (UAVs)</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post18-attacks-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.54260803711846;"
    data-aspect-ratio="0.543"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post18-attacks-sm-img"
      class="g-post18-attacks-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post18-attacks-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs"
      style="top:8.0859%;left:72.5585%;width:24.5098%;"
    >
      <p class="g-pstyle1">
        The attack drones Iran has used through the conflict are capable of
        striking ships. UAVs are relatively low‑cost, can be launched in
        numbers, and are difficult for civilian ships to defend against without
        naval escorts.
      </p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs"
      style="top:10.9586%;right:71.9776%;width:26.6667%;"
    >
      <p class="g-pstyle2">Shore‑based anti‑ship missiles</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs"
      style="top:15.3207%;right:71.912%;width:25.2941%;"
    >
      <p class="g-pstyle3">
        Iran deploys coastal missile batteries along its shoreline and islands
        overlooking key sea lanes.
      </p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.5842%;margin-top:-9.7px;left:11.965%;width:98px;"
    >
      <p class="g-pstyle4">Iran&rsquo;s shore</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:49.5437%;margin-top:-9.7px;left:37.1304%;margin-left:-52.5px;width:105px;"
    >
      <p class="g-pstyle5">Civilian ship</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs"
      style="top:73.4117%;right:66.1697%;width:21.9608%;"
    >
      <p class="g-pstyle2">Naval mines</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs"
      style="top:74.582%;left:63.5186%;width:21.9608%;"
    >
      <p class="g-pstyle0">Unmanned surface vessels</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs"
      style="top:75.8587%;right:66.1437%;width:30.5882%;"
    >
      <p class="g-pstyle3">
        Tehran may also deploy mines in the strait. U.S. intelligence estimates
        Iran has stockpiled as many as 6,000 mines, including drifting, limpet,
        bottom and moored mines.
      </p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs"
      style="top:78.9441%;left:63.5186%;width:32.549%;"
    >
      <p class="g-pstyle1">
        Another method is explosive‑laden unmanned boats or remotely operated
        craft. These are designed to approach ships near the waterline and
        detonate.
      </p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:97.6249%;margin-top:-9.6px;right:63.5859%;width:185px;"
    >
      <p class="g-pstyle6">Note: Diagram is not to scale.</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs"
      style="top:3.511%;left:72.5585%;width:26.6667%;"
    >
      <p class="g-pstyle0">Unmanned aerial vehicles (UAVs)</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post18-attacks-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.7426947208649;"
    data-aspect-ratio="0.743"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post18-attacks-md-img"
      class="g-post18-attacks-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post18-attacks-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs"
      style="top:8.1021%;right:9.0792%;width:20.6061%;"
    >
      <p class="g-pstyle0">Unmanned aerial vehicles (UAVs)</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs"
      style="top:12.6033%;right:77.7852%;width:19.5455%;"
    >
      <p class="g-pstyle1">
        Iran deploys coastal missile batteries along its shoreline and islands
        overlooking key sea lanes.
      </p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs"
      style="top:12.7158%;right:9.1408%;width:25.7576%;"
    >
      <p class="g-pstyle1">
        The attack drones Iran has used through the conflict are capable of
        striking ships. UAVs are relatively low‑cost, can be launched in
        numbers, and are difficult for civilian ships to defend against without
        naval escorts.
      </p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:22.018%;margin-top:-9.7px;left:27.3893%;width:98px;"
    >
      <p class="g-pstyle2">Iran&rsquo;s shore</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:43.061%;margin-top:-9.7px;left:35.3615%;margin-left:-52.5px;width:105px;"
    >
      <p class="g-pstyle3">Civilian ship</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs"
      style="top:63.6917%;right:12.169%;width:16.9697%;"
    >
      <p class="g-pstyle0">Unmanned surface vessels</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs"
      style="top:68.3054%;right:12.021%;width:25.1515%;"
    >
      <p class="g-pstyle1">
        Another method is explosive‑laden unmanned boats or remotely operated
        craft. These are designed to approach ships near the waterline and
        detonate.
      </p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs"
      style="top:71.6813%;right:60.5904%;width:16.9697%;"
    >
      <p class="g-pstyle0">Naval mines</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs"
      style="top:73.7068%;right:60.5417%;width:30.6061%;"
    >
      <p class="g-pstyle1">
        Tehran may also deploy mines in the strait. U.S. intelligence estimates
        Iran has stockpiled as many as 6,000 mines, including drifting, limpet,
        bottom and moored mines.
      </p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.8408%;margin-top:-9.6px;right:72.9696%;width:185px;"
    >
      <p class="g-pstyle4">Note: Diagram is not to scale.</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs"
      style="top:7.9896%;right:77.8359%;width:20.6061%;"
    >
      <p class="g-pstyle0">Shore‑based anti‑ship missiles</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post18-attacks-lg"
    class="g-artboard"
    style="min-width: 930px;max-width: 1199px;aspect-ratio: 1.0726943852477;"
    data-aspect-ratio="1.073"
    data-min-width="930"
    data-max-width="1199"
  >
    <div
      id="g-post18-attacks-lg-img"
      class="g-post18-attacks-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post18-attacks-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs"
      style="top:13.9566%;right:81.8207%;width:16.3441%;"
    >
      <p class="g-pstyle1">
        Iran deploys coastal missile batteries along its shoreline and islands
        overlooking key sea lanes.
      </p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.6067%;margin-top:-9.7px;left:28.6984%;width:98px;"
    >
      <p class="g-pstyle2">Iran&rsquo;s shore</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs"
      style="top:23.7608%;left:73.4246%;width:14.6237%;"
    >
      <p class="g-pstyle3">Unmanned aerial vehicles (UAVs)</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs"
      style="top:28.4898%;left:73.4246%;width:24.4086%;"
    >
      <p class="g-pstyle4">
        The attack drones Iran has used through the conflict are capable of
        striking ships. UAVs are relatively low‑cost, can be launched in
        numbers, and are difficult for civilian ships to defend against without
        naval escorts.
      </p>
    </div>
    <div
      id="g-ai3-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:43.7918%;margin-top:-9.7px;left:45.1036%;margin-left:-52.5px;width:105px;"
    >
      <p class="g-pstyle5">Civilian ship</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-text g-aiAbs"
      style="top:64.9384%;right:68.6003%;width:12.043%;"
    >
      <p class="g-pstyle0">Naval mines</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-text g-aiAbs"
      style="top:65.3998%;left:79.6364%;width:12.043%;"
    >
      <p class="g-pstyle3">Unmanned surface vessels</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-text g-aiAbs"
      style="top:67.1299%;right:68.5657%;width:21.7204%;"
    >
      <p class="g-pstyle1">
        Tehran may also deploy mines in the strait. U.S. intelligence estimates
        Iran has stockpiled as many as 6,000 mines, including drifting, limpet,
        bottom and moored mines.
      </p>
    </div>
    <div
      id="g-ai3-10"
      class="g-text g-aiAbs"
      style="top:70.1288%;left:79.6364%;width:17.8495%;"
    >
      <p class="g-pstyle4">
        Another method is explosive‑laden unmanned boats or remotely operated
        craft. These are designed to approach ships near the waterline and
        detonate.
      </p>
    </div>
    <div
      id="g-ai3-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.9175%;margin-top:-9.6px;right:78.8732%;width:185px;"
    >
      <p class="g-pstyle6">Note: Diagram is not to scale.</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs"
      style="top:9.2275%;right:81.8106%;width:14.6237%;"
    >
      <p class="g-pstyle0">Shore‑based anti‑ship missiles</p>
    </div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-post18-attacks-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 1.93548387096774;"
    data-aspect-ratio="1.935"
    data-min-width="1200"
  >
    <div
      id="g-post18-attacks-xl-img"
      class="g-post18-attacks-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post18-attacks-xl.jpg);"
    ></div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-13 11:31 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-13 11:31 -->
<!-- ai file: post18-attacks.ai -->
<style lang="scss">
  #g-post18-attacks-box {
    container-type: inline-size;
    container-name: g-post18-attacks-box;
  }
  #g-post18-attacks-box,
  #g-post18-attacks-box .g-artboard {
    margin: 0 auto;
  }
  #g-post18-attacks-box p {
    margin: 0;
  }
  #g-post18-attacks-box .g-aiAbs {
    position: absolute;
  }
  #g-post18-attacks-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post18-attacks-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post18-attacks-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post18-attacks-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post18-attacks-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post18-attacks-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post18-attacks-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post18-attacks-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-post18-attacks-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post18-attacks-xl {
        display: block !important;
      }
    }
  }
  #g-post18-attacks-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post18-attacks-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post18-attacks-xs .g-pstyle0 {
    font-weight: 500;
    padding-bottom: 9px;
  }
  #g-post18-attacks-xs .g-pstyle1 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post18-attacks-xs .g-pstyle2 {
    font-weight: 500;
    font-style: italic;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    color: rgb(102, 102, 102);
  }
  #g-post18-attacks-xs .g-pstyle3 {
    font-weight: 500;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post18-attacks-xs .g-pstyle4 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post18-attacks-xs .g-pstyle5 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
  }
  #g-post18-attacks-xs .g-pstyle6 {
    font-weight: 300;
    font-style: italic;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post18-attacks-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post18-attacks-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post18-attacks-sm .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-post18-attacks-sm .g-pstyle1 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post18-attacks-sm .g-pstyle2 {
    font-weight: 500;
    line-height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: right;
  }
  #g-post18-attacks-sm .g-pstyle3 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post18-attacks-sm .g-pstyle4 {
    font-weight: 500;
    font-style: italic;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    color: rgb(102, 102, 102);
  }
  #g-post18-attacks-sm .g-pstyle5 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
  }
  #g-post18-attacks-sm .g-pstyle6 {
    font-weight: 300;
    font-style: italic;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post18-attacks-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post18-attacks-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post18-attacks-md .g-pstyle0 {
    font-weight: 500;
    line-height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: right;
  }
  #g-post18-attacks-md .g-pstyle1 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post18-attacks-md .g-pstyle2 {
    font-weight: 500;
    font-style: italic;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    color: rgb(102, 102, 102);
  }
  #g-post18-attacks-md .g-pstyle3 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
  }
  #g-post18-attacks-md .g-pstyle4 {
    font-weight: 300;
    font-style: italic;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post18-attacks-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post18-attacks-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post18-attacks-lg .g-pstyle0 {
    font-weight: 500;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post18-attacks-lg .g-pstyle1 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post18-attacks-lg .g-pstyle2 {
    font-weight: 500;
    font-style: italic;
    height: 18px;
    padding-bottom: 9px;
    color: rgb(102, 102, 102);
  }
  #g-post18-attacks-lg .g-pstyle3 {
    font-weight: 500;
    padding-bottom: 9px;
  }
  #g-post18-attacks-lg .g-pstyle4 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post18-attacks-lg .g-pstyle5 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post18-attacks-lg .g-pstyle6 {
    font-weight: 300;
    font-style: italic;
    height: 18px;
    padding-bottom: 9px;
    font-size: 14px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-post18-attacks-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post18-attacks-xl p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post18-attacks-xl .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-post18-attacks-xl .g-pstyle1 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post18-attacks-xl .g-pstyle2 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
</style>
